// Max levels of order prices to show on UI
export const MAX_LEVELS = 30;

export const ORDER_BOOK_CONFIG = {
  heights: {
    ticker: 40,
    sideHeader: 20,
    row: 23,
    header: 40,
  },
  styles: {
    wrapper: {
      direction: 'column' as const,
      width: '100%',
      height: '100%',
      flex: '1 1',
    },
  },
} as const;

export const TICK_SCALES = [1, 2, 5, 10, 100, 1_000, 5_000];
